export default {
  /* eslint-disable eqeqeq */
  data: () => ({}),
  methods: {
    getStatus (status) {
      // PENDING - Aguardando pagamento
      // RECEIVED - Recebida (saldo já creditado na conta)
      // CONFIRMED - Pagamento confirmado (saldo ainda não creditado)
      // OVERDUE - Vencida
      // REFUNDED - Estornada
      // RECEIVED_IN_CASH - Recebida em dinheiro (não gera saldo na conta)
      // REFUND_REQUESTED - Estorno Solicitado
      // CHARGEBACK_REQUESTED - Recebido chargeback
      // CHARGEBACK_DISPUTE - Em disputa de chargeback (caso sejam apresentados documentos para contestação)
      // AWAITING_CHARGEBACK_REVERSAL - Disputa vencida, aguardando repasse da adquirente
      // DUNNING_REQUESTED - Em processo de recuperação
      // DUNNING_RECEIVED - Recuperada
      // AWAITING_RISK_ANALYSIS - Pagamento em análise
      let paymentStatus = this.translate('value.payment_status').find((val) => { return val.value === status })
      return paymentStatus ? paymentStatus.text : ''
    },
    getColorStatus (status) {
      switch (status) {
        case 'AWAITING_RISK_ANALYSIS':
        case 'CHARGEBACK_DISPUTE':
        case 'DUNNING_REQUESTED':
        case 'REFUND_REQUESTED':
        case 'PENDING': return 'chocolate'
        case 'RECEIVED_IN_CASH':
        case 'DUNNING_RECEIVED':
        case 'CONFIRMED':
        case 'RECEIVED': return 'darkgreen'
        case 'OVERDUE':
        case 'REFUNDED': return 'darkred'
        default: return '#444'
      }
    },
    getColorActiveStatus (date) {
      var expired = this.moment(date)
      var now = this.moment()
      if (expired < now) {
        // 'expired'
        return 'darkred'
      } else {
        // 'active'
        return 'darkgreen'
      }
    },
    getPaymentMethod (method) {
      if (method == -1) {
        return ''
      } else if (method == 'CREDIT_CARD') {
        return 'Cartão de Crédito'
      } else {
        return 'Boleto Bancário'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/planLayout.js